import React from "react";
import { newUserDatabaseAuthenticationRegistrationPath, newUserSessionPath } from "../../../../../../routes";

import Button from "../../ui/Button";

import { Box, Link } from "@chakra-ui/react";

export const DrawerLoginButton = () => {
  return (
    <>
      <Box px={5}>
        <Button size="sm" w="full" mt={4} as={Link} textDecoration="none" href={newUserSessionPath()}>
          ログイン
        </Button>
      </Box>
      <Box mt={4} px={5} py={4} backgroundColor="brand.50">
        <Button
          size="sm"
          w="full"
          as={Link}
          textDecoration="none"
          variant="outline"
          href={newUserDatabaseAuthenticationRegistrationPath()}
        >
          会員登録（無料）
        </Button>
      </Box>
    </>
  );
};
